import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/footer.png'


const _withScopeId = n => (_pushScopeId("data-v-6b93a9ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-footer" }
const _hoisted_2 = { class: "divFooter" }
const _hoisted_3 = {
  class: "elementFooterHaut",
  id: "elementFooterHautGauche"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lienTel" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "tel:+118883992393" }, [
    /*#__PURE__*/_createElementVNode("br", { class: "br" }),
    /*#__PURE__*/_createTextVNode("1 888 399-2393")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "elementFooterHaut",
  id: "elementFooterHautDroit"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "logoFooter",
      alt: "logo malecitesFooter"
    })
  ])
], -1))
const _hoisted_6 = { class: "barreBlancheFooter" }
const _hoisted_7 = { class: "elementFooter" }
const _hoisted_8 = { class: "admin" }
const _hoisted_9 = { class: "elementFooter" }
const _hoisted_10 = { class: "copyright" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://conceptionwm.com/" }, "Conception WebMédia.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('besoinAide')), 1),
        _createElementVNode("h2", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('contact')) + " ", 1),
          _hoisted_4
        ])
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, [
          _createVNode(_component_router_link, { to: { name: 'LoginAdmin' } }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('administration')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, [
          _createTextVNode(_toDisplayString(_ctx.$t('copyright')) + " ", 1),
          _hoisted_11
        ])
      ])
    ])
  ]))
}